import { render, staticRenderFns } from "./AddEditUser.vue?vue&type=template&id=5f12a5fe&scoped=true"
import script from "./AddEditUser.vue?vue&type=script&lang=js"
export * from "./AddEditUser.vue?vue&type=script&lang=js"
import style0 from "./AddEditUser.vue?vue&type=style&index=0&id=5f12a5fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f12a5fe",
  null
  
)

export default component.exports